import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    unreadMap: {},        // { chat_id: count }
    totalUnread: 0        // total unread across chats
};

const chatSlice = createSlice({
    name: "chat",
    initialState,
    reducers: {
        setUnreadCounts: (state, action) => {
            state.unreadMap = action.payload || {};

            // calculate total unread
            state.totalUnread = Object.values(state.unreadMap)
                .reduce((sum, count) => sum + count, 0);
        },

        clearChatUnread: (state, action) => {
            const chatId = action.payload;
            if (state.unreadMap[chatId]) {
                state.totalUnread -= state.unreadMap[chatId];
                state.unreadMap[chatId] = 0;
            }
        },

        clearAllUnread: (state) => {
            state.unreadMap = {};
            state.totalUnread = 0;
        }
    }
});

export const {
    setUnreadCounts,
    clearChatUnread,
    clearAllUnread
} = chatSlice.actions;

export default chatSlice.reducer;
